"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = require("redux");

var _isDataPage = require("./isDataPage");

var _permissions = require("./permissions");

var _tagIds = require("./tagIds");

var _displaySegmentIds = require("./displaySegmentIds");

var _dataMessage = require("./dataMessage");

// $FlowFixMe
var options = (0, _redux.combineReducers)({
  isDataPage: _isDataPage.isDataPage,
  permissions: _permissions.permissions,
  tagIds: _tagIds.tagIds,
  displaySegmentIds: _displaySegmentIds.displaySegmentIds,
  dataMessage: _dataMessage.dataMessage
});
var _default = options;
exports["default"] = _default;